import { IScheduleConfig } from "model/food/types/schedule.types"

export const validateEmail = (email: string) => {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return regex.test(email)
}

const MIN_LENGTH = 10
const MAX_LENGTH = 99

const alphabetCharacters = /[a-z]/i
const specialCharacters = "?=.*[!@#$&*]_-%^<>~/\\|{}+;:()`,\"'"
const numericCharacters = /\d/

function increaseCounter(acc: any, char: string, count = 1) {
  if (acc[`${char}`]) acc[`${char}`] += count
  else acc[`${char}`] = count

  return acc
}

export function hasLengthValid(password: string): boolean {
  return password.length >= MIN_LENGTH && password.length <= MAX_LENGTH
}

export function hasAlphabetCharacters(password: string): boolean {
  return alphabetCharacters.test(password)
}

export function hasSpecialCharacters(password: string): boolean {
  const occurrencesByChar = password.split("").reduce((acc: any, char) => {
    return increaseCounter(acc, char)
  }, {})

  const noOfSpecialChars = specialCharacters
    .split("")
    .reduce((acc: number, char) => {
      return acc + (occurrencesByChar[char] || 0)
    }, 0)

  return noOfSpecialChars > 0
}

export function hasNumericCharacters(password: string): boolean {
  return numericCharacters.test(password)
}

export function hasNotInvalidCharacters(password: string): boolean {
  const validCharacters =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789?=.*[!@#$&*]_-%^<>~/\\|{}+;:()`,\"'"
  const charactersMap = validCharacters
    .split("")
    .reduce((acc: { [key: string]: boolean }, char) => {
      acc[char] = true
      return acc
    }, {})

  return password.split("").every((char) => charactersMap[char])
}

export function checkIsPasswordValid(password: string): boolean {
  return (
    true &&
    hasLengthValid(password) &&
    hasAlphabetCharacters(password) &&
    hasSpecialCharacters(password) &&
    hasNumericCharacters(password) &&
    hasNotInvalidCharacters(password)
  )
}

export const isNotNullNotUndefined = (value: any) => {
  return value !== null && value !== undefined
}

export const validateScheduleConfig = (
  scheduleConfig: IScheduleConfig,
  hasEndDate: boolean,
) => {
  if (scheduleConfig.type !== "DAILY" && !scheduleConfig.daysOfWeek.length) {
    return false
  }

  if (scheduleConfig.type === "CUSTOM") {
    const isCustomRangeInvalid =
      !scheduleConfig.startDate || (hasEndDate && !scheduleConfig.endDate)

    return !isCustomRangeInvalid
  }

  return true
}
